import { AppHeaderLayout } from "@/composites/app-header-layout/index";
import { useContextPageRoot } from "../../context/root-context";
import { HeaderNavigateButtonMenu } from "./header-navigate-button-menu";
import { HeaderNavigateCart } from "./header-navigate-cart";
import { HeaderNavigateLogo } from "./header-navigate-logo";
import { HeaderNavigateMenu } from "./header-navigate-menu";
import { HeaderNavigateSignin } from "./header-navigate-signin";
import { HeaderNavigateUserMenu } from "./header-navigate-user-menu";

export const HeaderNavigate = () => {
  const { keycloak } = useContextPageRoot();
  const { authorize } = keycloak;

  return (
    <AppHeaderLayout
      logo={<HeaderNavigateLogo />}
      buttonMenu={<HeaderNavigateButtonMenu />}
      menu={<HeaderNavigateMenu />}
      signin={!authorize ? <HeaderNavigateSignin /> : undefined}
      userMenu={authorize ? <HeaderNavigateUserMenu /> : undefined}
      cart={authorize ? <HeaderNavigateCart /> : undefined}
    />
  );
};
